import React, { useState, useEffect } from "react";
import { AuthWrapper } from "../components/auth-wrapper";
import { useNavigate } from "react-router-dom";
import signinStore from "../../libs/stores/signin";

const Signin = () => {
  const navigate = useNavigate();

  const signinByEmail = signinStore((state) => state.signinByEmail);
  const signinByCode = signinStore((state) => state.signinByCode);
  const resendCode = signinStore((state) => state.resendCode);

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [isEmailLoading, setIsEmailLoading] = useState(false);
  const [isResendLoading, setIsResendLoading] = useState(false);
  const [isOtpLoading, setIsOtpLoading] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError("");
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    const newOtp = [...otp];
    if (/^\d$/.test(value)) {
      newOtp[index] = value;
      setOtp(newOtp);
      if (index < otp.length - 1) {
        document.getElementById(`otp-input-${index + 1}`)?.focus();
      }
    } else if (value === "") {
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      // Move to the previous box if the current box is empty
      if (index > 0) {
        document.getElementById(`otp-input-${index - 1}`)?.focus();
      }
    } else if (e.key === "Backspace" && otp[index] !== "") {
      // Clear the value in the current box on backspace
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const handleSendEmail = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }
    setIsEmailLoading(true);
    if (email) {
      try {
        const result = await signinByEmail(email);
        if (result === false) {
          alert("Couldn't send OTP, Try Again");
        } else {
          console.log("Sending OTP to email:", email);
          setIsOtpSent(true);
        }
      } catch (error) {
        console.error("Error during sign-in by email:", error);
      } finally {
        setIsEmailLoading(false);
      }
    }
  };

  const handleResendOtp = async () => {
    setIsResendLoading(true);

    try {
      await resendCode(email);
      console.log("Resending OTP...");
      alert("OTP sent to the email");
    } catch (error) {
      console.error("Error during resend OTP:", error);
    } finally {
      setIsResendLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.join("").length === 6 && otp.every((digit) => digit !== "")) {
      setIsOtpLoading(true);
      console.log("Verifying OTP:", otp.join(""));
      try {
        const result = await signinByCode(otp.join(""), email);
        if (result === false) {
          console.log("OTP verification failed");
          alert("Invalid OTP");
        } else {
          navigate("/home");
        }
      } catch (error) {
        console.error("Error during OTP verification:", error);
      } finally {
        setIsOtpLoading(false);
      }
    } else {
      alert("Please enter a valid OTP");
    }
  };

  const handleGoBack = () => {
    setIsOtpSent(false);
    setOtp(["", "", "", "", "", ""]);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        isOtpSent ? handleVerifyOtp() : handleSendEmail();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleSendEmail]);

  return (
    <AuthWrapper>
      <div>
        <h1
          style={{
            color: "var(--Black, #282828)",
            fontSize: "22px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "28px",
            alignSelf: "flex-start",
            marginBottom: "16px",
          }}
        >
          Sign In
        </h1>
        {!isOtpSent ? (
          <p
            style={{
              color: "#282828",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
              letterSpacing: "0.25px",
            }}
          >
            This page is intended for Leva Ops Team Members to view clinician
            availability.
          </p>
        ) : (
          <p
            style={{
              color: "#282828",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
              letterSpacing: "0.25px",
            }}
          >
            Please check your mail inbox to see the OTP verification code
          </p>
        )}

        <div style={{ marginTop: "16px", marginBottom: "16px" }}>
          {!isOtpSent ? (
            <div>
              <input
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Enter your email"
                style={{
                  width: "100%",
                  padding: "10px",
                  fontSize: "14px",
                  borderRadius: "5px",
                  border: emailError ? "1px solid red" : "1px solid #ddd",
                  marginBottom: "8px",
                  boxSizing: "border-box",
                }}
                onFocus={(e) => (e.target.style.outline = "1px solid black")}
                onBlur={(e) => (e.target.style.outline = "1px #ddd")}
              />
              {emailError && (
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "8px",
                  }}
                >
                  {emailError}
                </p>
              )}
              <button
                onClick={handleSendEmail}
                style={{
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "black",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  boxSizing: "border-box",
                }}
              >
                {isEmailLoading ? "Sending..." : "Send"}
              </button>
            </div>
          ) : (
            <div>
              <input
                type="email"
                value={email}
                disabled={true}
                style={{
                  width: "100%",
                  padding: "10px",
                  fontSize: "14px",
                  borderRadius: "5px",
                  border: "1px solid #ddd",
                  backgroundColor: "#f0f0f0",
                  color: "#888",
                  marginBottom: "16px",
                  boxSizing: "border-box",
                }}
              />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    value={digit}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    maxLength={1}
                    inputMode="numeric"
                    pattern="\d*"
                    style={{
                      width: "40px",
                      padding: "10px",
                      fontSize: "18px",
                      textAlign: "center",
                      borderRadius: "5px",
                      border: "1px solid #ddd",
                      margin: "0 5px",
                      boxSizing: "border-box",
                    }}
                    onFocus={(e) =>
                      (e.target.style.outline = "1px solid black")
                    }
                    onBlur={(e) => (e.target.style.outline = "1px #ddd")}
                  />
                ))}
              </div>
              <button
                onClick={handleVerifyOtp}
                style={{
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "black",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginTop: "16px",
                  boxSizing: "border-box",
                }}
              >
                {isOtpLoading ? "Verifying..." : "Verify OTP"}
              </button>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "16px",
                }}
              >
                <span
                  onClick={isResendLoading ? null : handleResendOtp}
                  style={{
                    textDecoration: "underline",
                    color: isResendLoading ? "gray" : "black",
                    cursor: "pointer",
                    marginBottom: "8px",
                  }}
                >
                  {"Resend OTP"}
                </span>
                <span
                  onClick={handleGoBack}
                  style={{
                    textDecoration: "underline",
                    color: "black",
                    cursor: "pointer",
                  }}
                >
                  Go Back
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </AuthWrapper>
  );
};

export default Signin;
